import { useEffect } from 'react'

/**
 * Calls `onEscape` when Escape is pressed while `active` is true.
 *
 * Keyboard twin of the click-outside backdrops used by popover menus and
 * simple modals: the backdrop `<div>` is mouse-only (aria-hidden), so Escape
 * is the keyboard way to dismiss the same surface (UX-20261031-18).
 */
export function useEscapeKey(active: boolean, onEscape: () => void): void {
  useEffect(() => {
    if (!active) return
    function onKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') onEscape()
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [active, onEscape])
}
